import { CustomDropDown } from "../custom-dropdown";

export namespace ServiceProviderSignUp {
  interface IServiceProvider {
    serviceProviderId: number;
    serviceProviderName: string;
    timeZone: string;
    firstName: string;
    middleName: string;
    lastName: string;
    phone: string;
    email: string;
    stripeToken: any;
    last4CardDigits: any;
    stripePlanId: number;
  }

  export class ServiceProvider implements IServiceProvider {
    public serviceProviderId: number;
    public serviceProviderName: string;
    public timeZone: string;
    public firstName: string;
    public middleName: string;
    public lastName: string;
    public phone: string;
    public email: string;
    public stripeToken: any;
    public last4CardDigits: any;
    public stripePlanId: number;

    public constructor(
      __serviceProviderId: number,
      __serviceProviderName: string,
      __timeZone: string,
      __firstName: string,
      __middleName: string,
      __lastName: string,
      __phone: string,
      __emailAddress: string,
      __stripeToken: any,
      __last4CardDigits: any,
      __stripePlanId: number,
    ) {
      this.serviceProviderId = __serviceProviderId;
      this.serviceProviderName = __serviceProviderName;
      this.timeZone = __timeZone;
      this.firstName = __firstName;
      this.middleName = __middleName;
      this.lastName = __lastName;
      this.phone = __phone;
      this.stripeToken = __stripeToken;
      this.last4CardDigits = __last4CardDigits;
      this.email = __emailAddress;
      this.stripePlanId = __stripePlanId;
    }
  }

  export class ServiceProviderEmail {
    public email: string;

    public constructor(_email: string) {
      this.email = _email;
    }
  }

  export class ServiceProviderProfile {
    public serviceProviderId: number;
    public serviceProviderName: string;
    public emailAddress: string;
    public phone: string;
    public phoneExt: string;
    public inboundCallNumber: string;
    public mailingAddress: any;
    public billingAddress: any;
    public technicianId: any;

    public constructor(
      __serviceProviderId: number,
      __serviceProviderName: string,
      __emailAddress: string,
      __phone: string,
      __phoneExt: string,
      __mailingAddress: any,
      __billingAddress: any,
      __technicianId: any,
      __inboundCallNumber: string,
    ) {
      this.serviceProviderId = __serviceProviderId;
      this.serviceProviderName = __serviceProviderName;
      this.emailAddress = __emailAddress;
      this.phone = __phone;
      this.phoneExt = __phoneExt;
      this.mailingAddress = __mailingAddress;
      this.billingAddress = __billingAddress;
      this.technicianId = __technicianId;
      this.inboundCallNumber = __inboundCallNumber;
    }
  }

  export class ServiceProviderLocationProfile {
    public serviceProviderLocationId: number;
    public name: string;
    public timeZone: string;
    public isDefault: boolean;
    public geoLocationLatitude: number;
    public geoLocationLongitude: number;
    public countryCode: string;

    public constructor(
      __serviceProviderLocationId: number,
      __name: string,
      __timeZone: string,
      __isDefault: boolean,
      __geoLocationLatitude: number,
      __geoLocationLongitude: number,
      __countryCode: string,
    ) {
      this.serviceProviderLocationId = __serviceProviderLocationId;
      this.name = __name;
      this.timeZone = __timeZone;
      this.isDefault = __isDefault;
      this.geoLocationLatitude = __geoLocationLatitude;
      this.geoLocationLongitude = __geoLocationLongitude;
      this.countryCode = __countryCode;
    }
  }

  export class ServiceProviderEmailConfiguration {
    public emailName: string;
    public emailConfig: string;
    public emailHostAddress: string;
    public emailConfigurationId: number;
    public clientId: number;
    public groupIds: number[];
    public ticketTags: string;
    public emailConfigurationStatus: number;
    public markAsDefault: boolean;
    public defaultTechnicianId: number;
    public applyClientGroups: boolean = true;
    public createEmailAlerts: boolean = true;
    public constructor(__emailName: string, __emailConfig: string) {
      this.emailName = __emailName;
      this.emailConfig = __emailConfig;
    }
  }

  export class CustomDomainConfiguration {
    public emailConfigurationStatus: number;
    public emailHostAddress: string;
    public dnsrecords: string;
    public verifiedSubDomain: string;

    public constructor(
      __emailConfigurationStatus: number,
      __emailHostAddress: string,
      __dnsrecords: string,
      __verifiedSubDomain: string,
    ) {
      this.emailConfigurationStatus = __emailConfigurationStatus;
      this.emailHostAddress = __emailHostAddress;
      this.dnsrecords = __dnsrecords;
      this.verifiedSubDomain = __verifiedSubDomain;
    }
  }

  export class BillingEmailConfiguration {
    public invoiceEmailFromName: string;
    public billingSettingId: number;
    public invoiceEmailAddress: string;
    public prefix: string;
    public suffix: string;
    public invoiceNumber: string;
    public currencyId: number | null;
    public serviceProviderId: number;
    public validEmail: boolean = true;

    public constructor(
      __billingSettingId: number,
      __invoiceEmailFromName: string,
      __invoiceEmailAddress: string,
    ) {
      this.invoiceEmailFromName = __invoiceEmailFromName;
      this.billingSettingId = __billingSettingId;
      this.invoiceEmailAddress = __invoiceEmailAddress;
    }
  }

  export class ServiceProviderCreditCard {
    public stripeCustomerId: string;
    public last4Digits: string;
    public isPay: boolean;

    public constructor(
      __isPay: boolean,
      __customerId: string,
      __last4Digits: string,
    ) {
      this.isPay = __isPay;
      this.stripeCustomerId = __customerId;
      this.last4Digits = __last4Digits;
    }
  }

  export class ServiceProviderDefaultLocation {
    public serviceProviderLocationId: number;
    public isDefault: boolean;
    public constructor(
      __serviceProviderLocationId: number,
      __isDefault: boolean,
    ) {
      this.serviceProviderLocationId = __serviceProviderLocationId;
      this.isDefault = __isDefault;
    }
  }

  export class ServiceProviderBillingSetting {
    public prefix: string;
    public invoiceNumber: number;
    public suffix: string;
    public currencyDropDownObject: CustomDropDown.IDropDown;
    constructor(
      __prefix: string,
      __invoiceNumber: number,
      __suffix: string,
      __clientObject: CustomDropDown.IDropDown,
    ) {
      this.prefix = __prefix;
      this.invoiceNumber = __invoiceNumber;
      this.suffix = __suffix;
      this.currencyDropDownObject = __clientObject;
    }
  }

  export class ServiceProviderBillingSettingResponse {
    public billingSettingId: number;
    public prefix: string;
    public invoiceNumber: number;
    public suffix: string;
    public currencyId: number;
    public isFromInvoices: boolean;
    public currencySymbol: string;
    public currencyName: string;
    public currencyCode: string;
  }

  export class CurrencyListResponse {
    public currencyId: number;
    public currencyName: string;
  }

  export class GetCXBrandingInfo {
    public domainUrl: string;

    public constructor(__domainUrl: string) {
      this.domainUrl = __domainUrl;
    }
  }
}

export namespace ServiceProviderDevice {
  export interface CreateDeviceActionButtonRequest {
    buttonName: string;
    actionScript: string;
  }
  export interface UpdateDeviceActionButtonRequest {
    buttonName: string;
    actionScript: string;
    deviceActionButtonId: number;
  }
  export interface GetDeviceActionButtonResponse {
    buttonName: string;
    actionScript: string;
    icon: string;
    createdById: number;
    deviceActionButtonId: number;
    isSignalrButton: boolean;
  }
}
